import React, { forwardRef } from "react";
import truncate from "truncate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

TimeAgo.addDefaultLocale(en);
const timeAgo = new TimeAgo("en-US");

export const capitalize = (word) => {
  return `${word.slice(0, 1).toUpperCase()}${word.slice(1).toLowerCase()}`;
};

const Post = forwardRef(
  (
    {
      external_image_cdn,
      comment,
      external_fullname,
      created,
      type,
      maxCommentLength = 300,
    },
    ref
  ) => {
    const displayName = external_fullname || `${capitalize(type)} User`;
    const localTime = new Date(`${created} UTC`).toString();

    return (
      <div
        className="flex absolute top-0 left-0 bg-gray-200 p-4 w-full rounded-md"
        ref={ref}
      >
        {external_image_cdn && (
          <div
            className="rounded-md bg-cover bg-no-repeat bg-center flex-grow-0 flex-shrink-0"
            style={{
              backgroundImage: `url(${external_image_cdn})`,
              width: "80px",
              height: "80px",
            }}
          />
        )}
        {!external_image_cdn && (
          <div
            className="rounded-md flex-grow-0 flex-shrink-0 bg-gray-400 flex items-center justify-center"
            style={{
              width: "80px",
              height: "80px",
            }}
          >
            <FontAwesomeIcon icon={"user-ninja"} size="3x" color="#666" />
          </div>
        )}
        <div className="flex flex-col pl-2">
          <div className="flex items-center place-content-between">
            <div className="flex items-center">
              <span className="font-bold">{displayName}</span>
              <span className="text-gray-600 text-xs ml-2">
                {timeAgo.format(new Date(localTime))}
              </span>
            </div>
          </div>
          <div className="pr-4">{truncate(comment, maxCommentLength)}</div>
          <FontAwesomeIcon
            icon={["fab", type]}
            size="lg"
            className="absolute right-0 top-0 m-4"
          />
        </div>
      </div>
    );
  }
);

export default Post;
